import React, { Component } from "react";
import {
  ActivityIndicator,
  View,
  TouchableOpacity,
  Image,
  Platform,
  Text,
  RefreshControl,
} from "react-native";
import moment from "moment";
import { connect } from "react-redux";

import Timeline from "react-native-timeline-flatlist";
import ParallaxScrollView from "react-native-parallax-scroll-view";

import Header from "../components/Header";
import PrescriptionHistoryItem from "../components/PrescriptionHistoryItem";

import fonts from "../constants/fonts";
import PatientAvatarWithDetail from "../components/PatientAvatarWithDetail";
import { APP_BASE_URL } from "../helpers/storage";
import { API } from "../helpers/axios";

class PrescriptionHistoryScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      refreshing: false,
      historyData: [],
    };
  }

  async fetchPrescriptionHistory(isInitializing) {
    if (!isInitializing) {
      this.setState({ refreshing: true });
    }

    try {
      const { patientId } = this.props.navigation.state.params;
      const {
        data: { data: prescriptionHistories },
      } = await API.get(
        `${APP_BASE_URL}/v2/profile/${patientId}/prescriptions`
      );

      const historyData = prescriptionHistories.map((val) => ({
        type: "section",
        date: moment(val.created_at).toDate(),
        icon: require("../assets/round_access_time_white_18dp.png"),
        prescription: {
          id: val.id,
          prescriptionNo: val.prescription_number,
          lifepackSubscriptionId: val?.lifepack_subscription_id ?? "-",
          patientName: val.transaction_dependency
            ? `${val.transaction_dependency.first_name} ${val.transaction_dependency.last_name}`
            : `${val.patient.patient_f_name} ${val.patient.patient_l_name}`,
          patientClass: val.patient.patient_class,
          status: val.order_status,
          prescriptionDate: moment(val.created_at).format("DD MMMM YYYY"),
          redeemDate: val?.claim_at
            ? moment(val.claim_at).format("DD MMMM YYYY")
            : "-",
          lifepack: {
            lifepackClaimId: val.lifepack_claim_id,
            lifepackClaimUrl: val.lifepack_claim_url,
            lifepackInvoiceUrl: val.lifepack_invoice_url,
            lifepackSubmitRequest: val.lifepack_submit_request,
            lifepackSubmitResponse: val.lifepack_submit_response,
            lifepackSubscriptionId: val.lifepack_subscription_id,
          },
        },
        createdAt: moment(val.created_at).toDate(),
      }));
      console.log({ prescriptionHistories });
      this.setState({ historyData, refreshing: false });
    } catch (error) {
      console.log(error?.response || error);
    }
  }

  async componentDidMount() {
    this.setState({ isLoading: true });

    await this.fetchPrescriptionHistory(true);

    this.setState({ isLoading: false });
  }

  render() {
    return (
      <ParallaxScrollView
        ref={(ref) => {
          this.scrollRef = ref;
        }}
        backgroundColor={this.props.themeColors.primary}
        parallaxHeaderHeight={200}
        refreshControl={
          <RefreshControl
            refreshing={this.state.refreshing}
            onRefresh={async () => await this.fetchPrescriptionHistory()}
          />
        }
        renderForeground={() => (
          <View>
            <Header
              onPress={() => {
                this.props.navigation.goBack();
              }}
              position="start"
              text="Kembali"
              theme="light"
            />
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                padding: 20,
              }}
            >
              <PatientAvatarWithDetail
                cardNumber={this.props.navigation.state.params.cardNumber}
                fullName={this.props.navigation.state.params.fullName}
                gender={this.props.navigation.state.params.gender}
              />
              <TouchableOpacity
                style={{ marginStart: 20 }}
                onPress={() => this.scrollRef.scrollTo({ x: 0, y: 500 })}
              >
                <Image
                  source={require("../assets/baseline_keyboard_arrow_up_white_18dp.png")}
                />
              </TouchableOpacity>
            </View>
          </View>
        )}
      >
        <View style={{ backgroundColor: this.props.themeColors.primary }}>
          {this.state.isLoading ? (
            <View
              style={{
                backgroundColor: "#FFF",
                borderTopEndRadius:
                  Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
                borderTopStartRadius:
                  Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
                paddingTop: 64,
              }}
            >
              <View
                style={{
                  flex: 1,
                  justifyContent: "center",
                }}
              >
                <ActivityIndicator
                  size="large"
                  color={this.props.themeColors.primary}
                />
              </View>
            </View>
          ) : (
            <View
              style={{
                backgroundColor: "#FFF",
                borderTopEndRadius:
                  Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
                borderTopStartRadius:
                  Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
                paddingTop: 16,
              }}
            >
              <View
                style={{
                  width: 64,
                  height: 6,
                  borderRadius: 3,
                  marginBottom: 15,
                  opacity: 0.5,
                  backgroundColor: "#808080",
                  alignSelf: "center",
                }}
              />
              <Text
                style={{
                  fontSize: 20,
                  ...fonts.bold,
                  color: this.props.themeColors.darkestPrimary,
                  alignSelf: "center",
                  marginBottom: 30,
                }}
              >
                Riwayat Resep
              </Text>
              <Timeline
                innerCircle="icon"
                circleColor={this.props.themeColors.lighterPrimary}
                lineColor={this.props.themeColors.primary}
                data={this.state.historyData}
                detailContainerStyle={{
                  marginTop: -13,
                  marginBottom: 13,
                }}
                listViewContainerStyle={{ marginLeft: 12, marginRight: 32 }}
                renderDetail={(rowData) => {
                  return (
                    <PrescriptionHistoryItem
                      createdAt={rowData.createdAt}
                      prescription={rowData.prescription}
                      navigation={this.props.navigation}
                    />
                  );
                }}
                showTime={false}
              />
            </View>
          )}
        </View>
      </ParallaxScrollView>
    );
  }
}

export default connect((state) => ({
  themeColors: state.themeColors,
}))(PrescriptionHistoryScreen);
